<template>
  <div>
    <!-- Start Page Title -->
    <div class="page-title-area">
      <div class="d-table">
        <div class="d-table-cell">
          <div class="container">
            <h2>A propos de nous</h2>
          </div>
        </div>
      </div>

      <div class="shape1">
        <img src="../../../assets/img/shape1.png" alt="IT+ formation cours informatique djibouti" />
      </div>
      <div class="shape2 rotateme">
        <img src="../../../assets/img/shape2.svg" alt="IT+ formation cours informatique djibouti" />
      </div>
      <div class="shape3">
        <img src="../../../assets/img/shape3.svg" alt="IT+ formation cours informatique djibouti" />
      </div>
      <div class="shape4">
        <img src="../../../assets/img/shape4.svg" alt="IT+ formation cours informatique djibouti" />
      </div>
      <div class="shape5">
        <img src="../../../assets/img/shape5.png" alt="IT+ formation cours informatique djibouti" />
      </div>
      <div class="shape6 rotateme">
        <img src="../../../assets/img/shape4.svg" alt="IT+ formation cours informatique djibouti" />
      </div>
      <div class="shape7">
        <img src="../../../assets/img/shape4.svg" alt="IT+ formation cours informatique djibouti" />
      </div>
      <div class="shape8 rotateme">
        <img src="../../../assets/img/shape2.svg" alt="IT+ formation cours informatique djibouti" />
      </div>
    </div>
    <!-- End Page Title -->

    <!-- Start About Area -->
    <section class="about-area ptb-80">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 col-md-12">
            <div class="about-image">
              <img src="../../../assets/img/1.png" alt="IT+ Code Lab" />
            </div>
          </div>

          <div class="col-lg-6 col-md-12">
            <div class="about-content">
              <div class="section-title">
                <h2>La Science des systemes d'information</h2>
                <div class="bar"></div>
              </div>

              <p>
                L'informatique est au coeur de presque toutes les activités
                quotidiennes, dans le domaine de la santé, de l'économie, de
                l'éducation et meme du divertissement. Elle a connu une
                croissance exponentielle au fil des années et promet d'évoluer
                encore plus.
              </p>
              <p>
                La carriere d'informaticien est trés prometeuse et garantit une
                offre d'embauche, les besoins en informaticiens ne cessant
                d'augmenter, il est necessaire d'etre armé de connaissances et
                d'experiences pratiques. Nous proposons des parcours et des
                formations certifiantes, nous vous guarantissant qualité et
                experience, et bien sur des formations mains à la pâtes oû vous
                aurez l'occasion de pratiquer et de voir les fruits de vos
                efforts.
              </p>
              <p>
                Rejoignez IT+, et découvrez nos multitudes de formations en
                programmation et en réseaux informatiques.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="container">
        <div class="about-inner-area">
          <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-6">
              <div class="about-text">
                <h3>Qui sommes nous?</h3>
                <p>
                  Une équipe experte composée des enseignants hautement
                  certifiés et qualifiés possédant une grande expérience dans
                  l'accompagnement des étudiants. Nous favorisons un plan de
                  formation continu adapté à l’évolution du marché IT et aux
                  besoins de nos étudiants.
                </p>
              </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6">
              <div class="about-text">
                <h3>Notre mission</h3>
                <p>
                  Nous réalisons des formations 100 % pratiques en programmation
                  et Réseaux Informatiques. Nous avons choisi une structure
                  simple et unifiée pour assurer une bonne communication et une
                  meilleure pédagogie.
                </p>
              </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6 offset-lg-0 offset-md-3 offset-sm-3">
              <div class="about-text">
                <h3>Notre expertise</h3>
                <p>
                  Nos procès rigoureux, l’accompagnement privilégié de nos
                  étudiants et l’implication d’une structure jeune et dynamique
                  nous permettent de concevoir des cours toujours plus
                  innovantes avec une haute qualité de service
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End About Area -->

    <!-- <Team></Team>

     Start Ready To Talk Area
    <section class="ready-to-talk">
      <div class="container">
        <h3>Ready to talk?</h3>
        <p>Our team is here to answer your question about StartP</p>
        <a href="#" class="btn btn-primary">Contact Us</a>
        <span><a href="#">Or, get started now with a free trial</a></span>
      </div>
    </section>
    End Ready To Talk Area
    <Partner></Partner>
    <Funfacts></Funfacts> -->
  </div>
</template>

<script setup>
import { useHead } from '@vueuse/head'
useHead({
  title: 'À Propos - IT+ CODE LAB',
  meta: [
    { name: 'description', content: 'Découvrez IT+ CODE LAB, le centre de formation de référence en informatique et technologies à Djibouti. | Code Lab | Cours et Formations en informatique à Djibouti' },
    { name: 'keywords', content: 'formation,formations,angular,vue, html, css,linux,sécurité,javascript, java, informatique,djibouti, Djibouti, programmation, réseaux, cours, codelab, it+' }
  ]
}); </script>
